import {
  Box,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography
} from '@mui/material';
import {
  DashboardOutlined,
  ShieldOutlined,
  PeopleOutline,
  ChatBubbleOutline,
  CreditCardOutlined,
  CampaignOutlined,
  HistoryOutlined
} from '@mui/icons-material';
import { Link, useLocation } from 'react-router-dom';
import { workspaces, workspaceFor } from '../navigation/workspaces';
import logo from '../assets/zenoo-logo.webp';
const icons = [
  DashboardOutlined,
  ShieldOutlined,
  PeopleOutline,
  ChatBubbleOutline,
  CreditCardOutlined,
  CampaignOutlined
];
export const drawerWidth = 236;
export default function Sidebar({ mobileOpen, onClose }) {
  const { pathname } = useLocation();
  const current = workspaceFor(pathname);
  const content = (
    <Box
      sx={{ height: '100%', display: 'flex', flexDirection: 'column', p: 2 }}
    >
      <Box
        component={Link}
        to="/dashboard"
        onClick={onClose}
        sx={{ px: 1.5, pt: 1.5, pb: 4, textDecoration: 'none' }}
      >
        <Box
          component="img"
          src={logo}
          alt="Zenoo"
          sx={{ width: 126, height: 'auto', display: 'block' }}
        />
        <Typography
          sx={{
            color: 'text.secondary',
            mt: 1,
            fontSize: 11,
            letterSpacing: '.12em'
          }}
        >
          ESPACE ÉQUIPE
        </Typography>
      </Box>
      <List aria-label="Navigation principale" sx={{ flex: 1, p: 0 }}>
        {workspaces.slice(0, 6).map((space, index) => {
          const Icon = icons[index];
          return (
            <ListItemButton
              component={Link}
              key={space.id}
              to={space.path}
              selected={space.id === current.id}
              onClick={onClose}
              sx={{
                borderRadius: 2,
                mb: 0.7,
                py: 1.3,
                '&.Mui-selected': { background: '#E8F0E9', color: '#243F32' }
              }}
            >
              <ListItemIcon sx={{ minWidth: 36, color: 'inherit' }}>
                <Icon sx={{ fontSize: 21 }} />
              </ListItemIcon>
              <ListItemText
                primary={space.label}
                primaryTypographyProps={{
                  fontSize: 14,
                  fontWeight: current.id === space.id ? 650 : 500
                }}
              />
            </ListItemButton>
          );
        })}
      </List>
      <ListItemButton
        component={Link}
        to="/audit-logs"
        selected={current.id === 'security'}
        onClick={onClose}
        sx={{ flex: '0 0 auto', borderRadius: 2, py: 1.3, mb: 2 }}
      >
        <ListItemIcon sx={{ minWidth: 36 }}>
          <HistoryOutlined sx={{ fontSize: 20 }} />
        </ListItemIcon>
        <ListItemText
          primary="Traçabilité"
          primaryTypographyProps={{ fontSize: 13 }}
        />
      </ListItemButton>
      <Box
        sx={{ borderTop: '1px solid', borderColor: 'divider', pt: 2, px: 1 }}
      >
        <Typography
          sx={{
            fontFamily: 'Georgia, serif',
            fontSize: 16,
            color: 'primary.dark'
          }}
        >
          Des rencontres en confiance.
        </Typography>
        <Typography sx={{ fontSize: 11, color: 'text.secondary', mt: 0.5 }}>
          Administration Zenoo
        </Typography>
      </Box>
    </Box>
  );
  return (
    <Box
      component="nav"
      sx={{ width: { md: drawerWidth }, flexShrink: { md: 0 } }}
    >
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={onClose}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': { width: drawerWidth }
        }}
      >
        {content}
      </Drawer>
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: 'none', md: 'block' },
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            background: '#FCFDFB',
            borderRight: '1px solid #E2E8DF'
          }
        }}
      >
        {content}
      </Drawer>
    </Box>
  );
}
